<template>
  <div class="background">
    <div class="canvas">
      <div class="main">
        <img class="logo" height="40px" src="@/assets/logo__.png" alt="" />

        <div class="content">

          <img height="70px" src="@/assets/ldl.png" alt="" />
          <br />
          <p class="login">Login</p>
          <!-- <div class="login-input"> -->
          <input type="text" placeholder="Email" v-model="email" />
          <br />
          <div class="submit-btn orange" v-if="submitting" style="margin-left: 170px">
            <loader />
          </div>
          <button class="submit-btn orange" @click="login" v-else>LOGIN</button>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/loader.vue";

export default {
  components: {
    Loader,
  },
  data() {
    return {
      submitting: false,
      error: "",

      email: "",
    };
  },
  methods: {
    login() {
      this.submitting = true;
      this.$http
        .post("signin", { email: this.email })
        .then((res) => {
          console.log(res.body);
          localStorage.setItem("access_token", res.body.token);
          localStorage.setItem("user", JSON.stringify(res.body.user));
          this.$store.commit("SET_SESSION");
          this.submitting = false;
          this.$router.push({ name: "dashboard-home" });
        })
        .catch((err) => {
          console.log(err);
          // this.error = err.body.message
          this.submitting = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
body,
html {
  height: 100%;
  background-color: #ff8b2c;
}
.background {
  background-image: url("../assets/camp_photo.jpg");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: center;
}
input {
  width: 100%;
  background-color: rgba($color: #e4e4e4, $alpha: 0.5);
  border-width: 0px;
  border-radius: 5px;
  font-family: "D-DIN";
  padding: 9px;
  margin-bottom: 10px;
}
.login {
  text-align: left;
  font-family: "D-DIN-bold";
  margin-left: 10px;
  margin-bottom: 5px;
  color: #ff8b2c;
  font-size: 35px;
}
.logo {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-bottom: 50px;
}
.main {
  // padding: 80px;
  // text-align: center;
  align-items: center;

  justify-content: space-between;
  //   background-color: orangered;
  //   opacity: 0.6;
  height: 100%;
  width: 50vw;
  padding-top: 50px;
}
.content {
  text-align: center;
  margin-left: 50px;
  align-self: center;
  background-color: white;
  padding: 20px 40px 90px 40px;
  border-radius: 7px;
  width: 25em;
  //   height: 50%;
  margin: 0 auto;
  justify-content: center;
  box-shadow: -3px 3px 3px -3px rgba($color: #000000, $alpha: 0.5);
}
.canvas {
  height: 100vh;
  width: 100vw;
}
.orange {
  align-self: left;
  background-color: #ff8b2c;
  align-self: flex-end;
  border-width: 0px;
  padding: 5px 25px 5px 25px;
  color: white;
  font-family: "D-DIN-bold";
  font-size: 18px;
  border-radius: 5px;
  margin-left: 220px;
}

@media screen and (max-width: 500px) {
  .content {
    width: 20em;
  }
  .orange{
      margin-left: 0px
  }
}

@media screen and (max-width: 895px) {
  .main {
    background-image: linear-gradient(rgb(253, 204, 113), #ff8b2c,#ff8b2c,#ff8b2c);
    // background-color: #ff8b2c;
    height: 100vh;
    width: 100vw;
    position: absolute;
  }
}
@media screen and (max-width: 325px) {
  .content {
    width: 15em;
  }
}
</style>